import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { TextsProvider } from './context/TextsContext';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Collections from './pages/Collections';
import CollectionDetail from './pages/CollectionDetail';
import Contact from './pages/Contact';
import Favorites from './pages/Favorites';
import Admin from './pages/Admin';
import AuthCallback from './pages/AuthCallback';
import SeriesList from './pages/SeriesList';
import SeriesDetail from './pages/SeriesDetail';
import EpisodeReader from './pages/EpisodeReader';
import Catalogue from './pages/Catalogue';
import ToonReader from './pages/ToonReader';
import WebtoonFiche from './pages/WebtoonFiche';
import News from './pages/News';
import Authors from './pages/Authors';
import AuthorDetail from './pages/AuthorDetail';
import About from './pages/About';
import LegacyRedirect from './pages/LegacyRedirect';
import { useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Detect OAuth callback fragment synchronously (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Lecteur canonique unique */}
        <Route path="/toon/:slug" element={<ToonReader />} />
        {/* Fiche éditoriale intermédiaire (données réelles) */}
        <Route path="/fiche/:slug" element={<Layout><WebtoonFiche /></Layout>} />
        {/* Lecteur épisodes (CMS séries réel + aperçu admin) */}
        <Route path="/lire/:slug" element={<EpisodeReader />} />
        <Route path="/apercu/:slug" element={<EpisodeReader preview={true} />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/catalogue" element={<Layout><Catalogue /></Layout>} />
        <Route path="/auteurs" element={<Layout><Authors /></Layout>} />
        <Route path="/auteur/:slug" element={<Layout><AuthorDetail /></Layout>} />
        <Route path="/apropos" element={<Layout><About /></Layout>} />
        <Route path="/actualites" element={<Layout><News /></Layout>} />
        <Route path="/series" element={<Layout><SeriesList /></Layout>} />
        <Route path="/serie/:slug" element={<Layout><SeriesDetail /></Layout>} />
        <Route path="/collections" element={<Layout><Collections /></Layout>} />
        <Route path="/collection/:slug" element={<Layout><CollectionDetail /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/favoris" element={<Layout><Favorites /></Layout>} />
        {/* Anciennes routes mock supprimées → redirection douce vers le catalogue */}
        <Route path="/webtoons" element={<LegacyRedirect />} />
        <Route path="/webtoon/:id" element={<LegacyRedirect />} />
        <Route path="/read/:id" element={<LegacyRedirect />} />
        <Route path="/artistes" element={<LegacyRedirect />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <FavoritesProvider>
            <TextsProvider>
              <AppRouter />
              <Toaster />
            </TextsProvider>
          </FavoritesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
